import { useContext } from 'react';

import { IInteractionLoginContext, InteractionLoginContext } from './InteractionLoginContext';

/**
 * Consume current login context.
 */
export function useInteractionLoginContext(): IInteractionLoginContext {
  return useContext(InteractionLoginContext);
}
